









import {
  Component,
  Prop,
  Vue
} from "@/shared/vuepack";
import ManagedExpenseColumnSortIcon from "@/employee/components/landing-pages/hsabank/expense/ManagedExpenseColumnSortIcon.vue";
import { ManagedExpensesSortableColumns } from "@/shared/types";
import { useManagedExpenseStore } from "@/employee/store/managedExpense";

@Component({
  computed: {
    ManagedExpensesSortableColumns () {
      return ManagedExpensesSortableColumns;
    }
  },
  components: { ManagedExpenseColumnSortIcon }
})
export default class ManagedExpenseColumnHeader extends Vue {
  managedExpensesStore = useManagedExpenseStore();

  @Prop({ required: true })
  managedExpenseColumn: ManagedExpensesSortableColumns;

  @Prop()
  text: string;

  @Prop({ default: true })
  sortable: boolean;

  onColumnHeaderClicked (col: ManagedExpensesSortableColumns) {
    if (this.sortable) {
      this.managedExpensesStore.setSortColumn(col);
    }
  }

  get rowClasses () {
    return {
      "row": true,
      "managed-expense-column-header": true,
      "sortable": this.sortable,
    };
  }
}
